import type {
  GeoJSON as GeoJSONLayer,
  Map,
} from 'leaflet';

export class OrderedLayerImportance {
  private static priority = 0;

  public importance: number;
  public sequenceNumber: string;
  currentPriority: number;
  // Below z-index 200 markers are not visible as they are getting "under the map"
  MINIMUM_VISIBLE_ZINDEX = 200;

  // Above z-index 500 markers are stacking on top of feature picker (Leaflet popup)
  MAXIMUM_NON_OVERLAPPING_ZINDEX = 500;

  // Step to downgrade z-index for each layer
  ZINDEX_DOWNGRADE_STEP = 50;
  constructor() {
    this.currentPriority = OrderedLayerImportance.priority;
    this.sequenceNumber = `grid-calculatator-importance-pane--${this.currentPriority}`;
    const zIndexImportance =
      this.MAXIMUM_NON_OVERLAPPING_ZINDEX -
      OrderedLayerImportance.priority * this.ZINDEX_DOWNGRADE_STEP;
    this.importance = Math.max(this.MINIMUM_VISIBLE_ZINDEX, zIndexImportance);
    OrderedLayerImportance.priority++;
  }
}

export class OrderedLayer {
  constructor(
    private readonly geojson: GeoJSONLayer,
    private readonly layerImportance: OrderedLayerImportance
  ) {}

  toGeoJson() {
    return this.geojson;
  }

  addTo(map: Map) {
    map.createPane(this.layerImportance.sequenceNumber);
    const pane = map.getPane(this.layerImportance.sequenceNumber);
    if (pane && pane.style && pane.style.zIndex) {
      pane.style.zIndex = this.layerImportance.importance.toString();
    }
    this.geojson.addTo(map);
  }
}
